import { memo, useState } from 'react'
import { useSelector } from 'react-redux'
import { getBreadcrumbs } from 'client/store/config/reducer'
import { sanitize } from '~/shared/xss'

export const BreadcrumbListStructuredDataWriter = memo(() => {
  const breadcrumbs = useSelector(getBreadcrumbs)

  const [structuredData] = useState({
    '@context': 'http://schema.org',
    '@type': 'BreadcrumbList',
    itemListElement: breadcrumbs?.map((breadcrumb) => ({
      position: breadcrumb.position,
      '@type': 'ListItem',
      item: {
        '@id': breadcrumb.url,
        name: breadcrumb.name,
      },
    })),
  })

  const sanitizedStructuredData = sanitize(JSON.stringify(structuredData))

  return <script dangerouslySetInnerHTML={{ __html: sanitizedStructuredData }} type="application/ld+json" />
})

BreadcrumbListStructuredDataWriter.displayName = 'ProductStructuredDataWriter'
